import request from "@/utils/request1";
import baseURL from "@/utils/baseUrl1";

const personService = {}
let base_url = baseURL.person

// 获取类型
personService.getType = function (parentCode) {
    return request ({
        url: '/report/getType',
        method: 'get',
        params: {
            parentCode: parentCode
        },
        baseURL: base_url
    })
}
// 个人分页查询
personService.querydishonesty = function (data) {
    return request ({
        url: '/report/report-result',
        method: 'get',
        params:data,
        baseURL: base_url,
    })
}
 //  个人/单位失信审核详情
 personService.querydetails = function(id){
    return request ({
        url: '/report/'+ id,
        method: 'get',
        baseURL: base_url,
    })
 }
  //  个人/单位流程图
  personService.querychart = function(id){
    return request ({
        url: '/report/'+ id,
        method: 'get',
        baseURL: base_url,
    })
 }
  // 个人文件下载
personService.addfiles = function (id) {
    return request ({
        url: `/file-deal/file-download?id=${id}`,
        method: 'get',
        baseURL: base_url,
        responseType: 'blob'
    })
}
// 获取验证码
personService.queryphone = function (phone) {
    return request ({
        url: `/send/code?phone=${phone}`,
        method: 'get',
        baseURL: base_url,
    })
}
// 撤回
personService.withdraw = function (id) {
    return request ({
        url: `/report/` + id,
        method: 'put',
        baseURL: base_url,
    })
}
// 撤销
personService.delete = function (id) {
    return request ({
        url: `/report/` + id,
        method: 'delete',
        baseURL: base_url,
    })
}
export default personService